
import { getCurrentInstance } from 'vue';

export default {
  name: "authFooterComponent",
  props: {
    activeSection: String,
  },
  setup(){
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    const emitToUsername = () => {
      emitter.emit('SWITCH_TO_USERNAME_LOGIN');
    }
    return {
      emitToUsername,
    }
  }
}
